import { Icon } from '../../../../layout/Icon.jsx';
import { Pill } from '../../../../layout/Pill.jsx';
import { formatIQD } from '../../../../shared/format.js';

const ROUNDING_LABEL = {
  exact: 'دقيق',
  ceil_half_hour: 'نصف ساعة',
  ceil_hour: 'ساعة كاملة'
};

export function RuleRow({ rule, canEdit, onEdit, onDelete, onSetDefault }) {
  const id = rule._id || rule.id;
  return (
    <tr className="border-b border-line">
      <td className="p-2.5">
        <div className="flex items-center gap-2">
          <span className="font-bold text-[13px]">{rule.name}</span>
          {rule.isDefault ? <Pill variant="orange">افتراضية</Pill> : null}
          {rule.isActive === false ? <Pill variant="muted">معطّلة</Pill> : null}
        </div>
      </td>
      <td className="p-2.5 font-bold" style={{ color: '#C2570D' }}>
        {formatIQD(rule.pricePerHour || 0)}
      </td>
      <td className="p-2.5">{formatIQD(rule.minimumCharge || 0)}</td>
      <td className="p-2.5">{rule.graceMinutes || 0} د</td>
      <td className="p-2.5">{ROUNDING_LABEL[rule.roundingType] || rule.roundingType || '—'}</td>
      <td className="p-2.5">
        {rule.holidayPrice ? formatIQD(rule.holidayPrice) : <span className="text-ink-3">—</span>}
      </td>
      <td className="p-2.5">
        {canEdit ? (
          <div className="flex items-center gap-1.5 justify-end">
            {!rule.isDefault ? (
              <button
                type="button"
                className="btn"
                style={{ padding: '4px 10px', fontSize: 12 }}
                onClick={() => onSetDefault?.(rule)}
                title="تعيين كافتراضي"
              >
                تعيين كافتراضي
              </button>
            ) : null}
            <button
              type="button"
              className="btn"
              style={{ padding: '4px 8px' }}
              onClick={() => onEdit?.(rule)}
              title="تعديل"
            >
              <Icon name="edit" size={13} />
            </button>
            <button
              type="button"
              className="btn btn-danger"
              style={{ padding: '4px 8px' }}
              onClick={() => onDelete?.(rule)}
              disabled={rule.isDefault}
              title={rule.isDefault ? 'لا يمكن حذف القاعدة الافتراضية' : 'حذف'}
            >
              <Icon name="trash" size={13} />
            </button>
          </div>
        ) : (
          <span className="text-ink-3 text-xs">للقراءة فقط</span>
        )}
      </td>
    </tr>
  );
}
